<template>
  <div>
    <div class="m-b-20 ovf-hd">
      <div class="fr">
        <router-link class="btn-link-large add-btn" to="add">
          <i class="el-icon-plus"></i>&nbsp;&nbsp;添加应用
        </router-link>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="名称" prop="name" width="200"></el-table-column>
      <el-table-column label="描述" prop="description"></el-table-column>
      <el-table-column label="类型" prop="type" width="200">
        <template scope="scope">
          <div>
            {{ scope.row.type | appType }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template scope="scope">
          <div>
            <router-link :to="{ name: 'appEdit', params: { id: scope.row.id }}" class="btn-link edit-btn m-r-5">编辑</router-link>
            <el-button size="small" @click="deleteApp(scope.row.id)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import http from 'assets/js/http'

  export default {
    name: 'application-list',
    data() {
      return {
        tableData: []
      }
    },
    methods: {
      async getApplication() {
        let tableData = []
        const result = await this.apiGet('mobile/use/index')
        if (result.code == 200) {
          tableData = result.data
        }
        return tableData
      },
      deleteApp(id) {
        this.$confirm('确认删除该应用?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.apiDelete('mobile/use/del/', id).then((res) => {
            if (res.code == 200) {
              _g.toastMsg(this, 'success', '删除成功')
              setTimeout(() => {
                _g.reloadPage(this)
              }, 1500)
            } else {
              _g.dealError(this, res)
            }
          })
        }).catch(() => {
        })
      }
    },
    filters: {
      appType(val) {
        let type = '未知应用'
        val = parseInt(val)
        switch (val) {
          case 10:
            type = '企业微信'
            break
          case 20:
            type = 'wap'
            break
          case 30:
            type = 'app'
            break
        }
        return type
      }
    },
    async created() {
      this.tableData = await this.getApplication()
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// list.vue?4cc913bf